import { render, staticRenderFns } from "./AppFormFieldGender.vue?vue&type=template&id=d2274604&"
import script from "./AppFormFieldGender.vue?vue&type=script&lang=js&"
export * from "./AppFormFieldGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports